var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-select',{attrs:{"label":_vm.label,"value":_vm.value,"validation-errors":_vm.validationErrors,"size":_vm.size,"help-text":_vm.helpText},on:{"change":_vm.handleInput}},_vm._l((_vm.users),function(user,index){return _c('option',{key:index,domProps:{"value":user.id}},[_vm._v(_vm._s(user.full_name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }